<template>
    <nav class="navbar header-navbar pcoded-header">
        <div class="navbar-wrapper d-flex align-items-center justify-between">

            <div class="navbar-logo justify-between">
                <a class="mobile-menu" id="mobile-collapse" href="javascript:void(0)">
                    <i class="ti-menu"></i>
                </a>
                <a href="/dashboard" class="d-flex align-items-center" style="margin: 0px; padding: 0px;">
                    <img src="../assets/img/logo.png" alt="Waje Recruitment Portal" style="height: 50px; width: auto;" />
                </a>
                <a class="mobile-options" href="javascript:void(0)" v-on:click="toggleMobileNav">
                    <i class="ti-more"></i>
                </a>
            </div>

            <div class="navbar-container container-fluid">
                <ul class="nav-left">
                    <li>
                        <div class="sidebar_toggle"><a href="javascript:void(0)"><i class="ti-menu"></i></a></div>
                    </li>
                    <li v-on:click="goBack" v-if="can_go_back">
                        <a href="javascript:void(0)">
                            <i class="ti-arrow-left"></i>
                        </a>
                    </li>
                    <li v-else>
                        <a href="javascript:void(0)" class="disabled">
                            <i class="ti-arrow-left"></i>
                        </a>
                    </li>
                    <li class="hidden-md">
                        <i class="ti-search"></i>
                        <input type="text" name="search" class="global-search" placeholder="Search Candidates by Name, Phone, Email, Referer, etc..."
                            v-model="search_query" v-on:keyup="search" />
                    </li>
                </ul>
                <ul class="nav-right">
                    <li class="user-profile header-notification">
                        <a href="javascript:void(0)">
                            <img src="../assets/img/avatar-4.jpg" class="img-radius" alt="User-Profile-Image">
                            <span>{{user_name}}</span>
                            <i class="ti-angle-down"></i>
                        </a>
                        <ul class="show-notification profile-notification">
                            <li>
                                <a href="/settings">
                                    <i class="ti-settings"></i> Settings
                                </a>
                            </li>
                            <li>
                                <a href="" v-on:click.prevent="logout">
                                    <i class="ti-layout-sidebar-left"></i> Logout
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="mobile-nav-panel" v-show="mobileNavOpen">
                <div class="mobile-nav-search">
                    <i class="ti-search"></i>
                    <input type="text" name="mobile-search" class="global-search" placeholder="Search Candidates by Name, Phone, Email, Referer, etc..."
                        v-model="search_query" v-on:keyup="search" />
                </div>
                <div class="mobile-nav-user">
                    <img src="../assets/img/avatar-4.jpg" class="img-radius" alt="User-Profile-Image">
                    <span>{{user_name}}</span>
                </div>
                <ul class="mobile-nav-links">
                    <li>
                        <a href="/settings">
                            <i class="ti-settings"></i> Settings
                        </a>
                    </li>
                    <li>
                        <a href="" v-on:click.prevent="logout">
                            <i class="ti-layout-sidebar-left"></i> Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<style scoped>
    ul {
        padding-left: 0 !important;
        list-style-type: none !important;
        margin-bottom: 0 !important;
    }

    .justify-between {
        justify-content: space-between !important;
    }

    @media only screen and (max-width: 992px) {
        .navbar-logo.justify-between .mobile-menu,
        .navbar-logo.justify-between .mobile-options {
            position: static !important;
            top: auto !important;
            left: auto !important;
            right: auto !important;
        }

        .navbar-container {
            display: none !important;
        }
    }

    .global-search {
        width: 480px;
        max-width: 100%;
        height: 45px;
        margin-top: 15px;
        padding: 7px;
        border: none;
        border-bottom: 1px solid #ccc;
        font-size: 16px;
    }

    .global-search-results {
        position: absolute;
        width: 100%;
        background: #fff;
        padding-left: 50px;
        padding-right: 50px;
        margin-top: 80px;
        min-height: 500px;
    }

    .disabled {
        color: #ccc !important;
        pointer-events: none;
    }

    .mobile-nav-panel {
        display: none;
    }

    @media only screen and (max-width: 992px) {
        .mobile-nav-panel {
            display: block;
            position: fixed;
            top: 80px;
            left: 0;
            width: 100%;
            background: #fff;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
            z-index: 1210;
            padding: 15px;
            box-sizing: border-box;
        }

        .mobile-nav-panel .mobile-nav-search {
            position: relative;
        }

        .mobile-nav-panel .global-search {
            width: 100%;
            margin-top: 0;
            padding-left: 30px;
            box-sizing: border-box;
        }

        .mobile-nav-panel .mobile-nav-search i {
            position: absolute;
            left: 5px;
            top: 12px;
        }

        .mobile-nav-panel .mobile-nav-user {
            display: flex;
            align-items: center;
            margin-top: 15px;
            padding-top: 15px;
            border-top: 1px solid #eee;
        }

        .mobile-nav-panel .mobile-nav-user img {
            width: 40px;
            border-radius: 50%;
            margin-right: 10px;
        }

        .mobile-nav-panel .mobile-nav-links li {
            padding: 10px 0;
        }

        .mobile-nav-panel .mobile-nav-links a {
            color: #333;
        }

        .mobile-nav-panel .mobile-nav-links i {
            margin-right: 8px;
        }
    }
</style>
<script>
    export default {
        name: 'navbar1',
        data() {
            return {
                user_name: '',
                search_query: '',
                can_go_back: false,
                mobileNavOpen: false
            }
        },
        methods: {
            toggleMobileNav() {
                this.mobileNavOpen = !this.mobileNavOpen
            },

            logout() {

                var r = window.confirm('Are you sure you want to logout?')

                if (r == true) {
                    this.$store.dispatch('logout')
                    window.location.reload()
                    //console.log(this.$store.getters)
                } else {
                    //
                }
            },

            goBack() {
                window.history.go(-1)
            },

            search: function (event) {

                if (event.which == 13 || event.keyCode == 13) {

                    let q = '/searchresults/?q=' + this.search_query

                    window.location.href = q
                }
            }
        },
        mounted() {
            var user = this.$store.getters.user_data

            this.user_name = user.data.first_name + " " + user.data.last_name

            this.can_go_back = window.history.length > 1
        }
    }
</script>
